import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import GoogleApiWrapper from 'components/GoogleMaps/lib/GoogleApiWrapper'

import Input from './Input'

class PlaceLookup extends Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    placeFound: PropTypes.func.isRequired,
  }

  render() {
    const { loaded, placeFound, } = this.props
    if (!loaded) {
      return <div>Loading...</div>
    }
    if (!placeFound) {
      return <div>Missing placeFound function</div>
    }
    return <Input {...this.props} />
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAS6CRIG3j--aBkQJA3pS01OboxE6wNpr4',
})(PlaceLookup)



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/PlaceLookup/index.js